import { Card, MenuItem, Select, TextField } from '@mui/material'
import Grid from '@mui/material/Grid'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import Loader from 'examples/Loader'
import { DateRangePicker } from 'rsuite'
import 'rsuite/dist/rsuite.min.css'

import CustomDataTable from '../Users/CustomDataTable'
import useAppData from './components/data-tables/data/dataTableData'

function BoostListings() {
  const {
    loader,
    downloading,
    dateRange,
    setDateRange,
    listingSlug,
    setListingSlug,
    email,
    setEmail,
    statusFilter,
    setStatusFilter,
    pagination,
    handlePageChange,
    handleLimitChange,
    downloadCsv,
    dataTableData,
  } = useAppData()

  return (
    <DashboardLayout>
      {loader ? (
        <Loader />
      ) : (
        <>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Grid container spacing={6}>
              <Grid item xs={12}>
                <Card>
                  <MDBox
                    mx={2}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <MDTypography variant="h6" color="white">
                      Boost Listings (Total: {pagination?.totalItems || 0})
                    </MDTypography>
                    <button
                      onClick={downloadCsv}
                      disabled={downloading}
                      style={{
                        background: downloading ? '#94A3B8' : '#16A34A',
                        color: 'white',
                        padding: '8px 14px',
                        borderRadius: '6px',
                        border: 'none',
                        cursor: downloading ? 'not-allowed' : 'pointer',
                        fontWeight: 600,
                      }}
                    >
                      {downloading ? 'Preparing CSV...' : 'Download CSV'}
                    </button>
                  </MDBox>

                  <MDBox pt={3} px={3} pb={0}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item>
                        <DateRangePicker
                          placeholder="Filter by start/end date"
                          value={
                            dateRange.startDate && dateRange.endDate
                              ? [new Date(dateRange.startDate), new Date(dateRange.endDate)]
                              : null
                          }
                          onChange={(range) => {
                            if (range) {
                              setDateRange({ startDate: range[0], endDate: range[1] })
                            } else {
                              setDateRange({ startDate: null, endDate: null })
                            }
                          }}
                          style={{
                            marginBottom: '8px',
                            backgroundColor: 'white',
                            borderRadius: '8px',
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          variant="outlined"
                          size="small"
                          placeholder="Listing slug"
                          value={listingSlug}
                          onChange={(e) => setListingSlug(e.target.value)}
                          sx={{ backgroundColor: 'white', borderRadius: '8px', width: 220 }}
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          variant="outlined"
                          size="small"
                          placeholder="Host email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          sx={{ backgroundColor: 'white', borderRadius: '8px', width: 250 }}
                        />
                      </Grid>
                      <Grid item>
                        <Select
                          size="small"
                          displayEmpty
                          value={statusFilter}
                          onChange={(e) => setStatusFilter(e.target.value)}
                          sx={{ backgroundColor: 'white', borderRadius: '8px', width: 160, height: 40 }}
                        >
                          <MenuItem value="">All statuses</MenuItem>
                          <MenuItem value="active">Active</MenuItem>
                          <MenuItem value="pending">Pending</MenuItem>
                          <MenuItem value="failed">Failed</MenuItem>
                        </Select>
                      </Grid>
                    </Grid>

                    <CustomDataTable
                      table={dataTableData}
                      canSearch={false}
                      entriesPerPage={{
                        defaultValue: pagination?.limit || 10,
                        entries: [10, 20, 50, 100],
                      }}
                      pagination={{
                        page: pagination.page,
                        limit: pagination.limit,
                        totalPages: pagination.totalPages,
                        totalUsers: pagination.totalItems,
                      }}
                      onPageChange={handlePageChange}
                      onLimitChange={handleLimitChange}
                    />
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </>
      )}
    </DashboardLayout>
  )
}

export default BoostListings
